// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"0bfc0c9a","111":"3908ab73","267":"82997baa","532":"5f8276f1","642":"05455eed","856":"84167e85","913":"c7aadc7c"}[chunkId] + ".chunk.js";
};